angular.module('unergie.main')
.controller('dashboardCtrl', ($scope, $sce, $stateParams, AuthService, BoFeaturesService) => {
    const metabasePublicUrl = BoFeaturesService.getModuleFeatures('general').publicMetabaseUrl
    $scope.metabaseDashboardUrl = $sce.trustAsResourceUrl(`${metabasePublicUrl}public/dashboard/${$stateParams.id}`)
})
